import color from "src/config/constants/Colors";
import { variantOptions } from "./interface";

const VARIANTS: variantOptions = {
  info: color.WHITE,
  error: color.CASCARA,
  success: color.MANTIS,
  warning: color.MANGO
};

export const sxConfig = {
  mainContainer: (width: number, variant: keyof typeof VARIANTS) => ({
    width,
    backgroundColor: VARIANTS[variant] || color.WHITE
  }),
  titleMainContainer: {
    margin: 0,
    padding: "12px"
  },
  mainTitle: (flexGrow: number) => ({ flexGrow }),
  messageContainer: { padding: "0px 12px 12px 10px", marginTop: -2 },
  viewInfoContainer: { marginLeft: "2px" },
  generateReportContainer: { marginLeft: "2px", marginBottom: 1.5 }
};
